import { haveProperty } from '@/utils/';

/**
 *
 * Criação do objecto de associação de gravações.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * editados na página é que serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = data => {
    const association = {
        ...( haveProperty( data, 'recording' ) && { origin_contact_call_id: data.recording }),
        ...( haveProperty( data, 'resources' ) && { file: data.resources[0] })
    };

    return association;
};
const requiredFields = [
    { field: 'call', isRequiredOnEdit: false },
    { field: 'resources', isRequiredOnEdit: false }
];
export {
    create,
    requiredFields
};